import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class RevenueShareRatioService {

    constructor(private http: HttpClient) { }

    export(filter: any): Observable<any> { //export
      return this.http.post(`${environment.apiUrl}/report/revenue-share-ratio/graph/export`, filter);
    }

    debtExport(filter: any): Observable<any> { //export
      return this.http.post(`${environment.apiUrl}/report/revenue-share-ratio/debt-graph/export`, filter);
    }
}
